import React, { useEffect, useRef, useState } from "react";
import "../components/css/style.css";

const logos = [
  {
    url: "https://moonmagicastrology.com/imgs/Moon%20Magic%20Astrology%20Logo.png",
    website: "https://moonmagicastrology.com",
    name: "Moon Magic Astrology"
  },
  {
    url: "https://res.cloudinary.com/duxydukde/image/upload/v1771156066/BuyHauteSauce_Logo2_jdsnxj.jpg",
    website: "https://www.buyhautesauce.com",
    name: "Buy Haute Sauce"
  },
  {
    url: "https://www.bookkish.in/imgs/Bookkish.in%20logo%20bg-removed.png",
    website: "#",
    name: "Bookkish.in"
  },
  {
    url: "https://res.cloudinary.com/duxydukde/image/upload/v1774467182/kr9wjielbzwdusxq7fo0.png",
    website: "#",
    name: "Unifits Fashion"
  },
  {
    url: "https://res.cloudinary.com/duxydukde/image/upload/v1774521917/mts8vwrvvch7qnnaten5.png",
    website: "https://flyinglearningaviation.com",
    name: "Flying Learning Aviation"
  },
  {
    url: "https://starlineairways.in/images/logo2.png",
    website: "https://starlineairways.in",
    name: "Starline Airways"
  },
  {
    url: "https://earnflyeducation.in/imgs/logo.png",
    website: "https://earnflyeducation.in",
    name: "Earnfly Education"
  },
  {
    url: "https://proindia.net/wp-content/uploads/2020/05/ProIndia-Solutions-Logo_stamp1-e1588360183120.png",
    website: "https://proindia.net",
    name: "Pro India Solutions"
  },
];

export default function TrustedBrandsSection() {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const sliderRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;
    if (!currentSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            entry.target.classList.add("section-visible");
            
            if (entry.target === currentSection) {
              const header = headerRef.current;
              const slider = sliderRef.current;
              
              if (header) {
                header.classList.add("animate-header");
              }
              
              if (slider) {
                slider.classList.add("animate-slider");
              }
            }
          }
        });
      },
      {
        threshold: 0.8,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    observer.observe(currentSection);

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const handleLogoClick = (website, brandName) => {
    window.open(website, "_blank", "noopener noreferrer");
  };

  const handleKeyDown = (e, website, brandName) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleLogoClick(website, brandName);
    }
  };

  return (
    <section 
      ref={sectionRef}
      className="trusted-section scroll-animate-section"
    >
      <div ref={headerRef} className="trusted-header scroll-animate-header">
        <p className="trusted-subtitle">
          Trusted Top Brands & Organizations
        </p>
        <h2 className="trusted-title">
          Powering Innovation <span className="text-highlight">Worldwide</span>
        </h2>
        <div className="title-underline"></div>
      </div>

      <div ref={sliderRef} className="trusted-slider-wrapper scroll-animate-slider">
        <div className={`trusted-slider ${isVisible ? 'animate-continuous' : ''}`}>
          {logos.map((logo, index) => (
            <div 
              className="trusted-logo" 
              key={`first-${index}`}
              onClick={() => handleLogoClick(logo.website, logo.name)}
              onKeyDown={(e) => handleKeyDown(e, logo.website, logo.name)}
              role="button"
              tabIndex={0}
              aria-label={`Visit ${logo.name} website`}
            >
              <div className="logo-container">
                <img 
                  src={logo.url} 
                  alt={`${logo.name} logo`} 
                  loading="lazy"
                />
              </div>
            </div>
          ))}
          {logos.map((logo, index) => (
            <div 
              className="trusted-logo" 
              key={`second-${index}`}
              onClick={() => handleLogoClick(logo.website, logo.name)}
              onKeyDown={(e) => handleKeyDown(e, logo.website, logo.name)}
              role="button"
              tabIndex={0}
              aria-label={`Visit ${logo.name} website`}
            >
              <div className="logo-container">
                <img 
                  src={logo.url} 
                  alt={`${logo.name} logo`} 
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="fade-left" />
      <div className="fade-right" />
    </section>
  );
}